"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullSubMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _rightCaretLightGray = _interopRequireDefault(require("../../../images/right-caret-light-gray.svg"));
var _rightCaretMediumGray = _interopRequireDefault(require("../../../images/right-caret-medium-gray.svg"));
var _NavBar = require("../../NavBar/NavBar");
var _formatID = _interopRequireDefault(require("../../../utils/formatID"));
var _SubMenu = _interopRequireDefault(require("./SubMenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FullSubMenu = props => {
  const {
    menuProps
  } = props;
  const {
    category,
    deployedSubsection,
    mouseOverSubsection,
    mouseOverTertiary,
    mouseOverWithKeysMegaMenu,
    setMaxActiveNavItems,
    megaMenuParentValue
  } = menuProps;
  const [isMousedOver, setIsMousedOver] = (0, _react.useState)(false);
  const [subMenuClicked, setSubMenuClicked] = (0, _react.useState)(null);
  const {
    mouse
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const isOpen = (0, _react.useMemo)(() => deployedSubsection === category?.contentfulId, [deployedSubsection, category]);
  const fullSubMenuParents = category?.links?.length;
  const fullSubMenuProps = {
    ...menuProps,
    fullSubMenuParents
  };
  const updateMaxActiveNavItems = (currentLinks, megaMenuValue, e) => {
    e.stopPropagation();
    let highest = currentLinks > megaMenuValue ? currentLinks : megaMenuValue;
    setMaxActiveNavItems(highest);
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: category?.contentfulId
  }, /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: mouse ? "" : "0",
    onMouseOver: () => {
      setIsMousedOver(true);
    },
    onMouseLeave: () => {
      setIsMousedOver(false);
    },
    onClick: e => {
      mouseOverSubsection(category?.contentfulId);
      mouseOverTertiary(null);
      setSubMenuClicked(true);
      updateMaxActiveNavItems(category?.links?.length, megaMenuParentValue, e);
    },
    onKeyDown: e => mouseOverWithKeysMegaMenu(e, category?.contentfulId),
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    "aria-label": `${category?.text} menu`
    // id={formatID(`${category?.text}-mega-menu-left-title-text`)}
    ,
    className: `ter-mega-menu__left-title ${isOpen ? "ter-mega-menu__left-title--is-open" : ""} ${mouse ? "" : "tabFocus"}`,
    "data-depth": 2
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-mega-menu__left-title--caret-wrapper`
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: `ter-mega-menu__left-title--text ${isOpen && !isMousedOver ? "ter-mega-menu__left-title--text--is-open" : ""}`
  }, category?.text), /*#__PURE__*/_react.default.createElement("img", {
    src: isMousedOver ? _rightCaretLightGray.default : _rightCaretMediumGray.default,
    alt: "right caret",
    "aria-label": isOpen ? "Expanded" : "Collapsed",
    className: "ter-mega-menu__left-title-caret"
  }))), /*#__PURE__*/_react.default.createElement(_SubMenu.default, {
    menuProps: fullSubMenuProps,
    isOpen: isOpen,
    links: category.links
  }));
};
exports.FullSubMenu = FullSubMenu;